import { FC } from 'react';

export const ErrorMessage: FC<{ error?: string }> = ({ error }) =>
  error ? <p style={{ fontSize: '14px', marginBottom: '0.5rem', color: '#eb6a6a' }}>{error}</p> : null;
